import createNotification from 'components/Settings/Utilities/CreateNotification';
import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';

const getShareContentTypeSlug = (page) => {
  if (page === 'policy-asks' || page === 'policy-ask') {
    return 'policy-ask';
  }

  if (page === 'briefing-materials') {
    return 'briefing-material';
  }

  if (page === 'news-releases') {
    return 'news-release';
  }

  if (page === 'researches') {
    return 'research';
  }

  return page;
};

const useStakeholdersOnlyShareLink = ({ id, data, page, contentTypeSlug }) => {
  const { generalApiCall } = useGeneralApiCall();

  const getStakeholdersOnlyShareLink = async () => {
    const targetId = Number(id ?? data?.id);

    if (!targetId) {
      createNotification('danger', 'Could not create share link: missing content ID.');
      return null;
    }

    const response = await generalApiCall({
      method: 'post',
      pathname: '/api/share-link',
      requestProperties: {
        targetContentUrlSlug: contentTypeSlug ?? getShareContentTypeSlug(page),
        targetId,
      },
      needsAuthentication: true,
      returnError: true,
      notShowErrorMessage: true,
    });

    if (!response || response?.status >= 400 || !response?.code) {
      const errorMessage =
        typeof response?.data === 'string'
          ? response.data
          : (response?.data?.message ?? 'Could not create share link.');
      createNotification('danger', errorMessage);
      return null;
    }

    return `${import.meta.env.VITE_APP_POLICYINFLUENCE_APP_URL}/share/${response.code}`;
  };

  return { getStakeholdersOnlyShareLink };
};

export default useStakeholdersOnlyShareLink;
